import { Pipe, PipeTransform } from '@angular/core';

/**
 * Devolve o valor apenas se ele for um array; senão, um array vazio.
 *
 * Existe por causa do `NG02200`: `*ngFor` sobre um valor não-iterável (string,
 * objeto, null) lança durante o change detection e, como o app não registra um
 * `ErrorHandler` global, **derruba a renderização da árvore inteira** — a
 * página fica em branco, não com um trecho faltando. Aconteceu de verdade na
 * tela de produto, com `especificacoes` chegando como texto da API.
 *
 * As guardas `*ngIf="algo?.length"` que existiam pelo código NÃO protegem:
 * string também tem `length`, então uma string não-vazia passa no `ngIf` e
 * quebra no `ngFor` logo em seguida.
 *
 * Use em todo `*ngFor` cujo iterável venha da API e não seja garantidamente
 * um array:
 *
 *   <li *ngFor="let x of produto?.imagens | asArray">
 */
@Pipe({
  name: 'asArray',
  pure: true,
})
export class AsArrayPipe implements PipeTransform {
  // Retorna `any[]` de propósito. Um genérico (`<T>(v: T[] | unknown): T[]`)
  // não infere quando a origem é tipada como `string` (é o caso de vários
  // campos em `FunctionsService`), e com `strictTemplates` o item vira
  // `unknown` — o template deixa de compilar ao acessar `item.url`. Aqui o
  // objetivo é robustez em runtime, não estreitar tipo.
  transform(value: unknown): any[] {
    return Array.isArray(value) ? value : [];
  }
}
